import React from "react";
import { NavLink } from "react-router-dom";

import styles from "./styles";
import * as Config from "../../helper/Configs";

export default function Resort(props) {
	const classes = styles();
    const { resort, type } = props;

	return (
		<li className={`${classes.wrapper} ${type == "contact" && "contactwrap"}`}>
			<div className={`${classes.left} leftclass`}>
				<div className={classes.content}>
					<span className="breve h1 newBrave">{resort.name}</span>
					<br />
					<br />
					<span>
						{type == "home" ? (
							<p>{resort.description}</p>
						) : (
							<p>
								{resort.address}
								<br />
								{resort.fax}
								<br />
								{resort.email}
								<br />
								{resort.phone}
							</p>
						)}
					</span>
					<span className={classes.discover}>
						<NavLink to={"/resort/" + resort.slug}>discover</NavLink>
					</span>
				</div>
			</div>
			<div className={classes.right}>
				<img src={`${Config.MEDIA_URL}images/${resort.image}`} alt="" />
			</div>
			<div className="clear"></div>
		</li>
	);
}
